import type { Observable } from 'rxjs';
import type { ActionRequest } from './action-request';
import type { ActionEvent } from './action-response';

/**
 * Dispatcher for `ActionRequests`.
 *
 * Used as a stub to be provide the actual implementation
 * via dependency injection and to wrap chained `ActionHandler`s
 * when passing them to the next `ActionHandler`.
 */
export abstract class ActionDispatcher {
  /**
   * Dispatches an action request.
   *
   * @param req Action request
   *
   * @returns
   * An `Observable` stream of action events
   */
  abstract dispatch(
    req: ActionRequest<unknown>,
  ): Observable<ActionEvent<unknown>>;

  /**
   * Emits an stream of boolean values indicating if the given
   * `action` can be executed.
   *
   * @param action Action identifier
   *
   * @returns
   * An `Observable` that emits whenever the executeable state of an
   * action changes.
   */
  abstract isExecuteable(action: string): Observable<boolean>;
}
